@if(showCartHeader){
<!-- Start::contact header -->
<div class="menu_b2c">
  <div class="row">
    <div class="col-sm-3" style="margin-top: 10px">
      <div class="site-header__logo">
        <a [routerLink]="['/', 'inicio']">
          <img
            height="110"
            src="assets/images/logos/logo_header.svg"
            alt="logo-implementos"
            title="logo-implementos"
            class="lazyload"
            loading="eager"
          />
        </a>
      </div>
    </div>
    @if(seller){

    <div class="col-sm-3 flex justify-content-start align-items-center p-0">
      <div class="site-header_info">
        <i
          class="fas fa-user fa-lg"
          style="margin-top: 15px; margin-right: 10px; font-size: 20px"
        ></i>
        {{ seller.name }}
      </div>
    </div>

    <div class="col-sm-3 flex justify-content-start align-items-center p-0">
      <div class="site-header_info">
        <i
          class="fas fa-envelope fa-lg"
          style="margin-top: 15px; margin-right: 10px; font-size: 20px"
        ></i>
        {{ seller.email }}
      </div>
    </div>

    <div class="col-sm-3 flex justify-content-start align-items-center p-0">
      <div class="site-header_info">
        <i
          class="fas fa-phone fa-lg"
          style="margin-top: 15px; margin-right: 10px; font-size: 20px"
        ></i>
        {{ seller.phone }}
      </div>
    </div>

    } @else {

    <div class="col-sm-3 flex justify-content-start align-items-center p-0">
      <div class="site-header_info">
        <i
          class="fas fa-bars fa-lg"
          style="margin-top: 15px; margin-right: 10px; font-size: 20px"
        ></i
        >Venta Telefónica {{ config.company.phone }}
      </div>
    </div>
    <div class="col-sm-3 flex justify-content-start align-items-center p-0">
      <div class="site-header_info">
        <i
          class="fas fa-envelope fa-lg"
          style="margin-top: 15px; margin-right: 10px; font-size: 20px"
        ></i>
        {{ config.company.email }}
      </div>
    </div>
    <div class="col-sm-3 flex justify-content-start align-items-center p-0">
      <div class="site-header_info">
        <i
          class="fas fa-truck fa-lg"
          style="margin-top: 15px; margin-right: 10px; font-size: 20px"
        ></i>

        @if(country=='pe') { Despachos a toda Lima Metropolitana y Callao }
        @else{ Despacho por todo {{ config.country }}
        }
      </div>
    </div>

    }
  </div>
</div>
<!-- End::contact header -->

} @if(desde !== 'omni'){
<div
  class="site-header__topbar topbar custom-topbar"
  style="background-color: #009579; height: 38px"
>
  <div
    class="topbar__container container flex align-items-center justify-content-center"
  >
    <div class="topbar__row">
      <i class="fas fa-truck fa-lg me-2"></i>
      {{ isStatic ? staticText : isB2B ? b2bText : b2cText }}
    </div>
  </div>
</div>
}
